import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../Stack/index.js';
import { Stack } from '../../../Stack/Stack.js';

var _excluded = ["children"];
var HeaderActionButtonsContainerComponent = function HeaderActionButtonsContainerComponent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // This component is a simple wrapper around the Stack component
    // In future this will be responsible to handle action items in a more complex way
    // like showing/hiding them based on the screen size or other conditions
    // For now, it just renders the children passed to it
    // and aligns them to the right
    // and adds a gap between them
    React.createElement(Stack, _extends({
      direction: "row",
      gap: "8",
      alignItems: "center",
      justifyContent: "flex-end"
    }, props), children)
  );
};
var HeaderActionButtonsContainer = /*#__PURE__*/React.memo(HeaderActionButtonsContainerComponent);
HeaderActionButtonsContainerComponent.displayName = 'Header.ActionButtonsContainer';

export { HeaderActionButtonsContainer, HeaderActionButtonsContainerComponent };
//# sourceMappingURL=HeaderActionButtonsContainer.js.map
